const KEY = 'shareAttribution';
const TTL_DAYS = 30;

// Remembers a visit coming from a shared link (utm_source=share) so the order can be attributed to it (30 days, last click wins)
export const captureShareAttribution = () => {
  try {
    const sp = new URLSearchParams(window.location.search);
    if (sp.get('utm_source') !== 'share') return;
    localStorage.setItem(KEY, JSON.stringify({ source: 'share', medium: sp.get('utm_medium') || '', campaign: sp.get('utm_campaign') || '', path: window.location.pathname + window.location.search, ref: (sp.get('ref') || '').toUpperCase().slice(0, 8), at: new Date().toISOString() }));
  } catch { /* storage unavailable */ }
};

export const getShareAttribution = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!a?.at || Date.now() - new Date(a.at).getTime() > TTL_DAYS * 86400000) return null;
    return a;
  } catch { return null; }
};

export const clearShareAttribution = () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } };
